import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";
import { Id } from "./id";
import { TerminalStatusLogEntry, TerminalStatusError, TerminalStatusErrorQuery } from "./log";

export const logApi = createApi({
    reducerPath: "logApi",
    baseQuery,
    tagTypes: ['Terminal', 'Log'],
    endpoints: (builder) => ({
        getTerminalStatusLog: builder.query<TerminalStatusLogEntry[], Id>({
            query: (organizationId) => `logs/terminal/status/list/${organizationId}`,
            providesTags: ['Terminal','Log'],
        }),
        getTerminalStatusError: builder.query<TerminalStatusError[], TerminalStatusErrorQuery>({
            query: (params) => ({
                url: "logs/terminal/error/list/",
                params,
            }),
            providesTags: ['Terminal','Log'],
        }),
    }),
});

export const { 
    useGetTerminalStatusLogQuery,
    useGetTerminalStatusErrorQuery,
 } = logApi;
